export enum fileTabVal {
    DETAILS = "details",
    WORKSPACE = "workspace",
    DOCUMENTS = "docs",
    CLIENTPORTAL = "clientportal",
    NEWHOME = 'newhome',
    EMPTY = ""
}

export type WritSearchType = {
    date: Date,
}

export type TitleSearchType = {
    date: Date,
}

export enum CONST {
    uninitialized = "uninit"
}

export type IndicatorBadgeType = {
    type: string,
    label: string,
    category:string,
}

export type TitleInsuranceType = {
    insuranceProvider : string,
}

export type MortgageType = {
    Lender: string,
    PSM: string,
    registrationDate: string,
    instrumentNumber: string,
    position: string,
    type: "New" | "VTB" | "Discharge" | "Assumed" | "Remaining" | "Postpone",
}
export type PersonType = {
    Name: string,
    personType: string,
    OtherPartyType?: string,
    address?: string,
}

export type RegistrationType = {
    Name: string,
    label: string,
}

export type FinanceType = {
    adjustment: {
        bdoc: number,
    },
    account: {
        owing: number,
    }
    trust: {
        buyer: number,
    },
    interimAdjustment: {
        interimBDOC: number,
    }
}

export type PurchaserType = {
    Name: string,
    IsPurchaser: string,
    OnTitle: string,
    personType: string,
    AddressForService: string,
    TransfereeNameFull: string,
    Birthday: string,
    Gender: string,
    TransfereeName: string,
    SpouseNotOnTitle?: string,
    SpouseEmailAddress?: string,
}

export type ContractType = {
   closingDate: Date,
   propertyAddress: string,
}

export type VendorType = {
   Name: string,
   IsVendor: string,
   OnTitle: string,
   personType: string,
   TransferorNameFull: string,
   TransferorName: string,
   AddressForService: string,
   Gender: string,
   HSTNumber: string,
   OnAgreementName?: string,
   SpouseNotOnTitle?: string,
   SpouseEmailAddress?: string,
}

export type GuarantorType = {
    Name: string, 
}

export type PriorOwnerType = {
    Name: string,
}

export type DepositType = {
    Amount: string,
}

export type PayeeType = {
    name: string;
    displayTitle: string;
    address: string;
}